import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { memo, useState } from 'react'
import TextField from '@mui/material/TextField'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

interface MuiDateTimePickerProps {
	value: Date | null
	onChange: (v: Date | null) => void
	label: string
}

export const MuiDateTimePicker = memo((props: MuiDateTimePickerProps) => {
	const { value, onChange, label } = props
	const [open, setOpen] = useState(false)

	const handleOpen = () => setOpen(true)
	const handleClose = () => setOpen(false)
	const handleChange = (value: Date | null) => onChange(value)

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<DateTimePicker
				label={label}
				value={value ?? null}
				open={open}
				inputFormat="yyyy-MM-dd HH:mm:ss"
				onClose={handleClose}
				onOpen={handleOpen}
				onChange={handleChange}
				renderInput={(params) => (
					<TextField
						{...params}
						size="small"
						sx={{ width: '14rem' }}
						onClick={handleOpen}
						inputProps={{
							...params.inputProps,
							readOnly: true
						}}
					/>
				)}
				ampm={false}
			/>
		</LocalizationProvider>
	)
})